import axios from "axios";
import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";

import { getBaseUrl } from "../../service/apiUrl";
export const STATUSES = Object.freeze({
    IDLE: 'idle',
    ERROR: 'error',
    LOADING: 'loading',
});

const getOwnerHorsesHistorySlice = createSlice({
    name: 'OwnerHorsesHistory',
    initialState: {
        data: [],
        status: STATUSES.IDLE,
    },

    extraReducers: (builder) => {
        builder
            .addCase(fetchOwnerHorsesHistory.pending, (state, action) => {
                state.status = STATUSES.LOADING;
            })
            .addCase(fetchOwnerHorsesHistory.fulfilled, (state, action) => {
                state.data = action.payload;
                state.status = STATUSES.IDLE
            })
            .addCase(fetchOwnerHorsesHistory.rejected, (state, action) => {
                state.status = STATUSES.ERROR;
            })
    }
});

export const { setOwnerHorsesHistory, setStatus } = getOwnerHorsesHistorySlice.actions;
export default getOwnerHorsesHistorySlice.reducer;

export const fetchOwnerHorsesHistory = createAsyncThunk('/OwnerHorsesHistoryget/fetch', async ({ horseid, id }) => {
    const res = await axios.get(`${getBaseUrl()}/OwnerHorsesHistory/${horseid}/${id}`);
    const OwnerHorsesHistoryData = res.data;
    return OwnerHorsesHistoryData.data;
})
